import React, { forwardRef } from 'react';
import BaseNumericInput from './BaseNumericInput';
import cn from 'classnames';

const ReadOnlyPercent = ({ value }) => {
  const readOnlyValue = value ? `${(value * 100)}%` : '0.00%';
  const className = cn('read-only', { empty: !value });

  return (
    <div className={className}>
      {readOnlyValue}
    </div>
  );
};

/**
 * @typedef {React.ComponentProps<BaseNumericInput>} BasePercentInputProps
 * @property {string} [format='p'] "p" by default.
 * @property {number} [min={0}] 0 by default.
 *
 * @param {BasePercentInputProps} props
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement}
 */
const BasePercentInput = ({ readOnly, ...props }, ref) => {
  if (readOnly) {
    return <ReadOnlyPercent {...props} />;
  }

  return <BaseNumericInput ref={ref} format="p" min={0} {...props} />;
};

/**
 * A base percent input component with various options and handlers
 *
 * @param {BasePercentInputProps} props Component props. Extends BaseNumericInput's props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement} Base percent input component.
 */
const ForwardPercentInput = forwardRef(BasePercentInput);

export default ForwardPercentInput;
